<script>

    import { timeFormat } from "d3";
    let { xScale, xTicks, chartheight=500, margin} = $props();

    // $inspect(xScale, xTicks, chartwidth)


</script>

{#if xScale && xTicks && chartheight}
    {#each xTicks as tick, i}
        <line x1={xScale(tick)} x2={xScale(tick)} y2={chartheight} y1={chartheight + 6} stroke-width=1></line>
        <text x={xScale(tick)} y={chartheight + 18} class="tick-text">{timeFormat('%Y')(tick)}</text>
    {/each}
{/if}

<style lang='scss'>
    line {
        stroke: $gray6;
        stroke-width: 1;
       
    }
    .tick-text {
        fill: #999;
        font-size: 11px;
        text-anchor: middle;  
    }
</style>